module.exports = __webpack_public_path__ + "static/img/kefu3.903ce097.png";